import { render, staticRenderFns } from "./SearchByKey.vue?vue&type=template&id=f07885ae&scoped=true&"
import script from "./SearchByKey.vue?vue&type=script&lang=js&"
export * from "./SearchByKey.vue?vue&type=script&lang=js&"
import style0 from "./SearchByKey.vue?vue&type=style&index=0&id=f07885ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07885ae",
  null
  
)

export default component.exports